import React, { useState } from "react"
import { InputBlock } from "../../../../generics/input-block"
import { useUsuario } from "../../../../../context/Suporte/CadastroUsuarioContext"
import { CadastroUsuarioRequest } from "../../../../../types/supervisao/usuario-interface"
import { useAuth } from "../../../../../context/AuthContext"
import { useModal } from "../../../../../hooks/ModalContext"

interface HandleChangeProps {
  event?: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  name?: string;
  value?: string;
}

interface FormCadastroUsuarioProps {
  setAba: React.Dispatch<React.SetStateAction<string>>
}


export const FormCadastroUsuario = ({ setAba }: FormCadastroUsuarioProps) => {
  const { perfils, credores, cadastrarUsuario, getUsuario } = useUsuario()
  const { cookies } = useAuth()
  const { setModal } = useModal()

  const [cadastroUsuario, setCadastroUsuario] = useState<CadastroUsuarioRequest>({} as CadastroUsuarioRequest)
  const [listaDisc, setListaDisc] = useState<string[]>([])

  function maskCPFCNPJ(value: string) {
    if (value) {
      if (value.length >= 15) {
        return value
          .replace(/\D/g, '')
          .replace(/^(\d{2})(\d)/, '$1.$2')
          .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          .replace(/\.(\d{3})(\d)/, '.$1/$2')
          .replace(/(\d{4})(\d)/, '$1-$2');
      } else {
        return value
          .replace(/\D/g, '')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d{1,2})/, '$1-$2')
          .replace(/(-\d{2})\d+?$/, '$1');
      }
    }
  }


  function handleChange({ event, name }: HandleChangeProps) {
    if (event && !name) {
      const { name, value } = event.target;
      let nome = name === 'CPF/CNPJ' ? 'cpf_cnpj' : name === 'Nome Completo' ? 'name' : name === 'Usuário Discador' ? 'usuarioDiscador' : name === 'Senha Discador' ? 'senhaDiscador' : name === 'Token/Url Discador' ? 'urlDiscador' : name === 'Senha' ? 'password' : name.toLocaleLowerCase()

      setCadastroUsuario(prevState => ({
        ...prevState,
        [nome]: value,
      }));

      return
    }
  };

  function handleCheckBoxDiscador(disc: string) {

  }

  function handleCheckBox(id_credor: number) {
    let credoresNovos = [] as number[]
    const hasCredor = cadastroUsuario.credores?.find(item => item === id_credor)
    if (hasCredor) {
      const credoresUsuario = cadastroUsuario.credores?.filter(item => item !== id_credor)
      setCadastroUsuario(prevState => ({
        ...prevState,
        credores: credoresUsuario,
      }));
      return
    }

    if (cadastroUsuario?.credores && cadastroUsuario?.credores?.length > 0) {
      credoresNovos = [...cadastroUsuario?.credores, id_credor]
    } else {
      credoresNovos = [id_credor]
    }
    setCadastroUsuario(prevState => ({
      ...prevState,
      credores: credoresNovos,
    }));
  }

  async function handleCadastro() {

    // if ((Number(cadastroUsuario.id_perfil) === 2 && !cadastroUsuario.urlDiscador)) {
    //   setModal('Valor do "Token/ Url Discador" é obrigatório! Por favor, tente novamente', 'Erro', false, true)
    //   return
    // }

    if ((Number(cadastroUsuario.id_perfil) === 2 && cadastroUsuario.credores?.length === 0) || (Number(cadastroUsuario.id_perfil) === 2 && !cadastroUsuario.credores)) {
      setModal('Usuário sem credor! Por favor, tente novamente', 'Erro', false, true)
      return
    }

    if (!cadastroUsuario.email || !cadastroUsuario.login || !cadastroUsuario.password || !cadastrarUsuario.name || !cadastroUsuario.cpf_cnpj) {
      setModal('Os dados do usuário estão incompletos! Por favor, tente novamente', 'Erro', false, true)
      return
    }

    const usuario: CadastroUsuarioRequest = {
      ...cadastroUsuario,
      id_user_support: cookies?.user?.id_operador,
      cpf_cnpj: cadastroUsuario.cpf_cnpj.replace(/\D/g, ''),
      id_perfil: Number(cadastroUsuario.id_perfil)
    }

    await cadastrarUsuario(usuario)
    await getUsuario()
    setAba('Usuários')
  }



  return (
    <div className={`flex max-h-full min-h-full w-full rounded-md bg-white px-4 py-4 gap-2`}>
      <div className="w-full">
        <div className="border-2 border-primary p-4 m-2">
          <h4 className="font-semibold text-primary text-base">Dados do Usuário</h4>
          <div className="mt-2">
            <InputBlock name="Nome Completo" onChange={e => { handleChange({ event: e }) }} value={cadastroUsuario.name} />
          </div>


          <div className="w-[100%] mt-2">
            <p className="text-sm font-medium text-gray-800">
              Perfil
            </p>
            <select className="w-full rounded-sm bg-gray-200 p-2 text-gray-600 outline-none text-xs" name="id_perfil" value={cadastroUsuario.id_perfil} onChange={e => { handleChange({ event: e }) }} >
              {
                perfils && perfils?.length > 0 && perfils.map(pe => (
                  <option value={pe.id_perfil} key={pe.id_perfil}>{pe.perfil}</option>
                ))
              }
            </select>
          </div>

          <div className="my-2 flex w-full items-center gap-2">
            <div className="mt-2 w-full"><InputBlock name="CPF/CNPJ" onChange={e => { handleChange({ event: e }) }} value={maskCPFCNPJ(cadastroUsuario.cpf_cnpj)} /></div>
            <div className="mt-2 w-full"> <InputBlock name="Login" onChange={e => { handleChange({ event: e }) }} value={cadastroUsuario.login} /></div>
          </div>

          <div className="my-2 flex w-full items-center gap-2">
            <div className="mt-2 w-full"><InputBlock name="Email" onChange={e => { handleChange({ event: e }) }} value={cadastroUsuario.email} /></div>

            <div className="mt-2 w-full"> <InputBlock name="Senha" onChange={e => { handleChange({ event: e }) }} value={cadastroUsuario.password} /></div>
          </div>


          {/* <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        className="h-4 w-4 rounded-sm accent-primary"
                        id={String(credor.id_credor)}
                        onChange={() => handleCheckBox(credor.id_credor)}
                        checked={cadastroUsuario?.credores?.find(item => item === credor.id_credor) ? true : false}
                      />
                      <label htmlFor={String(credor.id_credor)}>{credor.name_credor}</label>
                    </div> */}

        </div>

        {
          cadastroUsuario && Number(cadastroUsuario.id_perfil) === 2 && (
            <div className="border-2 border-primary p-4 m-2">
              <h4 className="font-semibold text-primary text-base">
                Credores Habilitados
              </h4>
              <div className=" items-center gap-2 p-2  grid grid-cols-2">

                {
                  credores && credores?.length > 0 && credores.map(credor => (

                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        className="h-4 w-4 rounded-sm accent-primary"
                        id={String(credor.id_credor)}
                        onChange={() => handleCheckBox(credor.id_credor)}
                        checked={cadastroUsuario?.credores?.find(item => item === credor.id_credor) ? true : false}
                      />
                      <label htmlFor={String(credor.id_credor)}>{credor.name_credor}</label>
                    </div>
                  ))
                }
              </div>

            </div>
          )
        }

      </div>
      <div className="w-full">
        {
          cadastroUsuario && Number(cadastroUsuario.id_perfil) === 2 && (
            <>
              <div className="border-2 border-primary p-4  m-2">
                <h4 className="font-semibold text-primary text-base">Dados do Discador Expert</h4>

                <div className="my-2 flex w-full items-center gap-2">
                  <div className="mt-2 w-full"><InputBlock name="Usuário Discador" onChange={e => { handleChange({ event: e }) }} value={cadastroUsuario.usuarioDiscador} /></div>

                  <div className="mt-2 w-full"><InputBlock name="Senha Discador" onChange={e => { handleChange({ event: e }) }} value={cadastroUsuario.senhaDiscador} /></div>
                </div>

                <div className="mt-2"><InputBlock name="Token/Url Discador" onChange={e => { handleChange({ event: e }) }} value={cadastroUsuario.urlDiscador} /></div>

              </div>


              <div className="border-2 border-primary p-4  m-2">
                <h4 className="font-semibold text-primary text-base">Dados do Discador 3C</h4>
                <div className="mt-2"><InputBlock name="Token" onChange={e => { handleChange({ event: e }) }} value={cadastroUsuario.urlDiscador} /></div>

              </div>
            </>



          )
        }

        {/* {
          cadastrarUsuario && Number(cadastrarUsuario.id_perfil) === 2 &&  ()
        } */}



        <button className="bottom-10 right-32 m-4 absolute bg-primary rounded-md text-white p-2" onClick={() => handleCadastro()}>Cadastrar Usuário</button>
      </div>


    </div>
  )
}